import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { SubTabs, SubTab } from 'components/layout'
import {
  TasksSectionsTable,
  TasksResidentialProjectSignoff
} from 'components/sections/tasks'
import { meta, tableCommon } from 'helpers/decorators'
import {
  apiTasksSectionSignoff,
  apiActivities,
  apiResidentialProjects,
  apiTasksRp, apiConfiguration
} from 'helpers/decorators/api'
import { modal } from 'redux/modules/app'
import { ACTIVITY_SECTIONS, CONFIGURATION_KEYS } from 'constants/enums'

@meta({
  title: 'Tasks - Section signoff',
  intlKey: 'pageTitle.tasks_activity_signoffs'
})
@connect(({ auth }) => ({
  activeOrganization: auth.organization
}), { modal })
@apiTasksSectionSignoff({
  list: true,
  useCommonLimit: true
})
@apiTasksRp({
  listSignoff: true
})
@apiActivities({
  updateSectionTasks: true
})
@apiResidentialProjects({
  updateSignoffTasks: true
})
@tableCommon()
@apiConfiguration()
class TasksSectionSignoff extends Component {
  static propTypes = {
    tasks: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    signoffActivity: PropTypes.func.isRequired,
    returnSignoffActivity: PropTypes.func.isRequired,
    signoffResidentialProject: PropTypes.func.isRequired,
    returnSignoffResidentialProject: PropTypes.func.isRequired,
    setRpSignoffParams: PropTypes.func.isRequired,
    setSectionSignoffParams: PropTypes.func.isRequired,
    setCommonLimit: PropTypes.func,
    configuration: PropTypes.object.isRequired,
    onGetConfigurationValue: PropTypes.func.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    isAssessorManagementEnabled: PropTypes.bool
  }

  state = {
    defaultTab: 0
  }

  async componentDidMount() {
    const orgId = get(this.props, 'activeOrganization.id')

    orgId && this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isAssessorReportAdditionalInfoEnabled.id, orgId)
  }

  handleTabChanged = id => {
    this.setState({
      defaultTab: id
    })
  }

  render() {
    const {
      tasks,
      tasks: { sectionSignoff: { list }, rp },
      signoffActivity,
      returnSignoffActivity,
      signoffResidentialProject,
      returnSignoffResidentialProject,
      setSectionSignoffParams,
      setRpSignoffParams,
      setCommonLimit,
      configuration,
      activeOrganization,
      isAssessorManagementEnabled
    } = this.props
    const { defaultTab } = this.state

    const physicalTasks = list.filter(
      item =>
        get(item, 'activity.activitySection.value') ===
        ACTIVITY_SECTIONS.physical.id
    )
    const skillsTasks = list.filter(
      item =>
        get(item, 'activity.activitySection.value') ===
        ACTIVITY_SECTIONS.skills.id
    )
    const serviceTasks = list.filter(
      item =>
        get(item, 'activity.activitySection.value') ===
        ACTIVITY_SECTIONS.service.id
    )

    const orgId = get(activeOrganization, 'id')

    const isAssessorReportAdditionalInfoEnabled = get(configuration, `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.isAssessorReportAdditionalInfoEnabled.id}].booleanValue`)

    const isPersonalReflectionEnabled = get(configuration, `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.isPersonalReflectionFroActivityEnabled.id}].booleanValue`)

    return (
      <div>
        <SubTabs onChange={this.handleTabChanged} defaultActive={defaultTab}>
          <SubTab
            title="Physical recreation"
            svg="physical"
            intlKey="award.physical_recreation"
            progress={physicalTasks.length}
          >
            <TasksSectionsTable
              tasks={tasks.sectionSignoff}
              list={physicalTasks}
              approveModal={signoffActivity}
              returnModal={returnSignoffActivity}
              modal={this.props.modal}
              setSectionSignoffParams={setSectionSignoffParams}
              setCommonLimit={setCommonLimit}
              isAssessorReportAdditionalInfoEnabled={isAssessorReportAdditionalInfoEnabled}
              isPersonalReflectionEnabled={isPersonalReflectionEnabled}
            />
          </SubTab>
          <SubTab
            title="Skills"
            svg="skills"
            intlKey="award.skills"
            progress={skillsTasks.length}
          >
            <TasksSectionsTable
              tasks={tasks.sectionSignoff}
              list={skillsTasks}
              approveModal={signoffActivity}
              returnModal={returnSignoffActivity}
              modal={this.props.modal}
              setSectionSignoffParams={setSectionSignoffParams}
              setCommonLimit={setCommonLimit}
              isAssessorReportAdditionalInfoEnabled={isAssessorReportAdditionalInfoEnabled}
              isPersonalReflectionEnabled={isPersonalReflectionEnabled}
            />
          </SubTab>
          <SubTab
            title="Service"
            svg="service"
            intlKey="award.service"
            progress={serviceTasks.length}
          >
            <TasksSectionsTable
              tasks={tasks.sectionSignoff}
              list={serviceTasks}
              approveModal={signoffActivity}
              returnModal={returnSignoffActivity}
              modal={this.props.modal}
              setSectionSignoffParams={setSectionSignoffParams}
              setCommonLimit={setCommonLimit}
              isAssessorReportAdditionalInfoEnabled={isAssessorReportAdditionalInfoEnabled}
              isPersonalReflectionEnabled={isPersonalReflectionEnabled}
            />
          </SubTab>
          <SubTab
            title="Residential Project"
            svg="rp"
            intlKey="award.rp"
            progress={rp.signoff.list.length}
          >
            <TasksResidentialProjectSignoff
              tasks={rp.signoff}
              list={rp.signoff.list}
              approveModal={signoffResidentialProject}
              returnModal={returnSignoffResidentialProject}
              modal={this.props.modal}
              setParams={setRpSignoffParams}
              setSectionSignoffParams={setSectionSignoffParams}
              isAssessorManagementEnabled={isAssessorManagementEnabled}
              hideLimit
            />
          </SubTab>
        </SubTabs>
      </div>
    )
  }
}

export default TasksSectionSignoff
